var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulkActionPreferredLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8226 5C15.7419 5 18.9187 8.13373 18.9187 12C18.9187 15.8663 15.7419 19 11.8226 19M11.8226 5C13.2817 5 14.4634 8.13373 14.4634 12C14.4634 15.8663 13.2817 19 11.8226 19M11.8226 5C10.3635 5 9.18077 8.13373 9.18077 12C9.18077 15.8663 10.3635 19 11.8226 19M11.8226 5C8.47048 5 5.66158 7.29224 4.9187 10.3745M11.8226 19C8.51578 19 5.73761 16.7693 4.94995 13.75M5.52644 8.76736C6.72242 9.13136 8.02198 9.37882 9.35835 9.51731C10.9824 9.68531 12.6587 9.68531 14.2904 9.51731C15.6267 9.37882 16.9263 9.13136 18.1223 8.76736M18.1223 15.2306C16.9263 14.8666 15.6267 14.6191 14.2904 14.4806C12.6587 14.3126 10.9824 14.3126 9.35835 14.4806C8.02198 14.6191 6.72242 14.8666 5.52644 15.2306",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkActionPreferredLanguage);
export default __webpack_public_path__ + "static/media/bulk-action-preferred-language.d1f78b5407e2622a2a642f568dc288b5.svg";
export { ForwardRef as ReactComponent };